import useUser from 'hooks/useUser';

export const useOrganisationPermission = () => {
  const { user } = useUser();

  const canManageOrganisationPermission =
    user?.data?.organisation?.can_manage_organisation;

  return {
    canManageOrganisationPermission,
  };
};
